import { render, staticRenderFns } from "./OrganisationNotActive.vue?vue&type=template&id=c49697c8&scoped=true&lang=pug&"
var script = {}
import style0 from "./OrganisationNotActive.vue?vue&type=style&index=0&id=c49697c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c49697c8",
  null
  
)

export default component.exports